<template>
    <div class="vh-100">

        <!-- HEADER -->
        <div class="header-top bg-white">
            <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                <div class="header-top--left" @click="backtolistpotongansx">
                    <div class="header-item">
                        <img src="../../../assets/icons/back-blue.svg" alt="a">
                    </div>
                </div>
                <div class="header-top--middle f-cont f-16 f-bold">Bayar Denda</div>
                <div class="header-top--right">
                    <div class="header-item"></div>
                </div>
            </div>
        </div>

        <!-- CONTENT -->
        <div class="content-wrapper main-page">
            <div class="m-t-16 m-d-16 p-x-20 w-limit">
                <div class="d-flex justify-content-between">
                    <div class="f-16 f-semi">{{namakaryawan_potonganbayarx}}</div>
                    
                    <!-- 
                    ## statuses class
                    .badge.color-red = belum lunas
                    .badge.color-yellow = cicilan
                    .badge.color green = lunas 
                    -->
                    <div class="badge color-red" v-if="statuspelunasanbayar===0">Belum Lunas</div>
                    <div class="badge color-yellow" v-if="statuspelunasanbayar===2">Cicil</div>
                </div>
                <div class="f-13  f-c-midgrey" v-if="this.statusoutletbayarx==='true'"><b>Kasir</b> {{namaoutletbayarx}}</div>
                <div class="f-13  f-c-midgrey" v-if="this.statusworkshopbayarx==='true'"><b>Workshop</b> {{namaworkshopbayarx}}</div>
                <div class="f-13  f-c-midgrey" v-if="this.statuskurirbayarx==='true'" id="statuskurirx"><b>Kurir</b></div>
            </div>

            <div class="separator-line-dot w-limit"></div>

            <div class="w-limit p-x-20 p-y-16" v-if="statuspelunasanbayar===0">
                <div id="tgl-kasbon-bayarlunas" class="d-flex justify-content-between">
                    <div class="f-16 f-c-midgrey">Tgl Denda</div>
                    <div class="f-16">{{date_lunas_potonganbayarx}}</div>
                </div>
                <div id="total-kasbon" class="m-t-8 d-flex justify-content-between">
                    <div class="f-16 f-c-midgrey">Total Denda</div>
                    <div class="f-16 f-semi">Rp {{nominal_pembayaranx}}</div>
                </div>
            </div>
            <div class="detail-cicilan--wrapper w-limit" v-else>
                <div class="separator-line-dot"></div>
                <div class="p-x-20 p-y-16">
                    <div id="tgl-kasbon-bayarlunas" class="d-flex justify-content-between">
                        <div class="f-16 f-c-midgrey">Tgl Denda</div>
                        <div class="f-16">{{date_lunas_potonganbayarx}}</div>
                    </div>
                </div>

                <div class="separator-line-dot"></div>
                <div class="p-x-20 p-y-16">
                    <div class="d-flex justify-content-between">
                        <div class="f-14 f-c-midgrey">Total Denda</div>
                        <div class="f-14 f-c-midgrey">Rp {{nominal_pembayaranx}}</div>
                    </div>
                    <div class="m-t-8 d-flex justify-content-between">
                        <div class="f-14 f-c-midgrey">Terbayar</div>
                        <div class="f-14 f-c-midgrey">Rp {{sisabayarx}}</div>
                    </div>
                    <div class="m-t-8 d-flex justify-content-between" @keyup="inputnominalsisabayar">
                        <div class="f-16 f-c-midgrey">Sisa Bayar</div>
                        <div class="f-16 f-semi">Rp {{saldo_potonganbayarx}}</div>
                    </div>
                    <div class="m-t-8" @click="riwayatcicil(dataidpotonganx.idpotonganx)">
                        <div class="f-c-blue f-14 f-semi m-r-4" @click="riwayatcicil(dataidpotonganx.idpotonganx)">
                          Riwayat Cicilan
                          <img src="../../../assets/icons/chevron-right1.svg" height="14px" alt="">
                        </div>
                    </div>
                </div>
            </div>

            <div class="separator-line-dot w-limit"></div>
            <div class="w-limit p-x-20 p-y-16">
                <div class="f-16 f-c-midgrey">Keterangan</div>
                <div class="f-16">{{keterangankaryawan_potonganbayarx}}</div>
            </div>

            <div class="separator"></div>

            <form class="w-limit p-x-20 p-t-16">

                <label for="radio1" class="form-label">Tipe Pembayaran</label>
                <div class="radio-group">
                    <div class="radio-wrapper">
                        <div class="radio-item" @click="showinputlunas">
                            <input type="radio" id="radio1" name="radioboxx" v-model="tipepembayaraan" value="1">
                            <label for="radio1">Lunas</label>
                        </div>
                        <div class="radio-item" @click="showinputcicil">
                            <input type="radio" id="radio2" name="radioboxx" v-model="tipepembayaraan" value="2">
                            <label for="radio2">Cicilan</label>
                        </div>
                    </div>
                </div>

                <label class="m-t-16 form-label require">Nominal</label>
                <div class="input-group mod" id="inputdis" v-if="statuspelunasanbayar===0">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Rp</span>
                    </div>
                    <input type="tel" class="form-control" placeholder="Masukkan nominal..."
                        disabled v-model="nominal_pembayaranx" @keyup="inputnominallunas">
                </div>

                <div class="input-group mod" id="inputdis" v-else>
                    <div class="input-group-prepend">
                        <span class="input-group-text">Rp</span>
                    </div>
                    <input type="tel" class="form-control" placeholder="Masukkan nominal..."
                           disabled v-model="saldo_potonganbayarx" @keyup="inputnominalcicillunas">
                </div>

                <div class="input-group mod" id="input-nominal-cicil">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Rp</span>
                    </div>
                    <input type="tel" class="form-control" placeholder="Masukkan nominal..."
                            v-model="nominal_cicil_bayarx" @keyup="inputnominalcicil">
                </div>

                <div class="form-group mod m-t-16">
                    <label for="tgl_potonganx" class="form-label require">Tanggal Pelunasan</label>
                    <input type="datetime-local" min="" class="form-control" id="tgl_potonganx"
                    v-model="date_potongan_bayarx" @change="onchangedate">
	                <span id="cekTanggalValid" style="color: red; display: none">
		                <small>Waktu pelunasan tidak boleh kurang dari tanggal pembuatan denda / melebihi waktu saat ini</small>
	                </span>
                </div>

                <div class="mod m-t-16">
                    <label class="form-label require">Masuk ke akun</label>
                    <select class="form-control" v-model="selectedx" @change="onchangeselect">
                        <option value="" selected>
                            Pilih Akun Keuangan
                        </option>
                        <optgroup  label="Aset">
                        </optgroup>
                        <optgroup  label="Kas">
                            <option v-for="optionx in selectedakun" v-bind:value="{value:optionx.id, text: optionx.text}" v-if="optionx.idkategori==='1.01.000'" >{{optionx.text}}</option>
                        </optgroup>
                        <optgroup label="Bank">
                            <option v-for="optionx in selectedakun" v-bind:value="{value:optionx.id, text: optionx.text}" v-if="optionx.idkategori==='1.02.000'">{{optionx.text}}</option>
                        </optgroup>
                    </select>
	                <ErrorMessage class="error" label="Akun" :validation="$v.selectedx.value"></ErrorMessage>
                </div>

            </form>

            <div class="w-limit p-x-20 p-t-24 p-d-20">
                <button class="btn smart-primary" id="BtnBayarPotongan" @click="createbayarpotongan" v-if="statuspelunasanbayar===0">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                          v-if="isClicked === true"></span><span id="textBtnBayarPotongan">Bayar</span></button>
                <button class="btn smart-primary" id="BtnBayarPotongancicil" @click="createbayarpotongancicil" v-else>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                          v-if="isClicked === true"></span><span id="textBtnBayarPotongancicil">Bayar</span></button>
                <button class="btn smart-primary" id="BtnBayarPotongans" @click="createbayarpotongans">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                          v-if="isClicked === true"></span><span id="textBtnBayarPotongans">Bayar</span></button>
            </div>

        </div>

    </div>
</template>

<script>
    import Select2 from 'v-select2-component';
    import ErrorMessage from "@/component-items/ErrorMessage";
    import {minLength, required} from "vuelidate/lib/validators";
    export default {
        components: {
            Select2,
	        ErrorMessage,
        },
        props:['dataidpotonganx', 'idkaryawan'],
        data(){
            return{
                isClicked:'',
                detailpotonganbayarx:{},
                idpotongan_bayarx:'',
                idkaryawan_potonganbayarx:'',
                namakaryawan_potonganbayarx:'',
                keterangankaryawan_potonganbayarx:'',
                saldo_potonganbayarx:'',
                nominal_pembayaranx:'',
                nominal_cicil_bayarx:'',
                test_nominal_cicil:'',
                date_lunas_potonganbayarx:'',
                date_potongan_bayarx:'',
                waktu_pembayaraan_bayar:'',
                namaworkshopbayarx:'',
                namaoutletbayarx:'',
                statusoutletbayarx:'',
                statusworkshopbayarx:'',
                statuskurirbayarx:'',
                statuspelunasanbayar:0,
                statusriwayatbayar_bayar:0,
                selectedakun:[],
                selectedx:'',
                idkategori:'',
                tipepembayaraan:'1',
                sisabayarx:'',
                hasilrupiahsisax:'',
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                }
            }
        },
	    validations: {
		    selectedx: {
			    value: {
			    	required
			    },
		    },
	    },
        mounted(){
            this.getDetailpotonganbayarsx();
            this.getdatakaunx()
	        this.showinputlunas()

			this.backButtonPressed(this.backtolistpotongansx)
        },
        methods:{
            backtolistpotongansx(){
                this.$emit('backtolistpotx')
            },

            riwayatcicil(id){
                this.$emit('riwayatpotongan',{id: id, islunas: 0})
            },

            onchangedate(){
                this.Cekvalidasicicil();
                this.Cekvalidasi();
                this.Cekvalidasicicillunas()
            },

            onchangeselect(){
                this.Cekvalidasicicil();
                this.Cekvalidasi();
                this.Cekvalidasicicillunas()
            },

            showinputcicil(){
                var value = $("input[name=radioboxx]:checked").val()
                $("#radio2").prop("checked", true);
                this.tipepembayaraan = value;
                $('#input-nominal-cicil').show();
                $('#BtnBayarPotongans').show();
                $('#BtnBayarPotongan').hide();
                $('#inputdis').hide();
                $('#BtnBayarPotongancicil').hide()
                // this.tipepembayaraan = 2;
                this.Cekvalidasicicil();
            },

            showinputlunas(){
                var value = $("input[name=radioboxx]:checked").val()
                $("#radio1").prop("checked", true);tam
                this.tipepembayaraan = value
                $('#inputdis').show();
                $('#input-nominal-cicil').hide();
                $('#BtnBayarPotongans').hide();
                $('#BtnBayarPotongan').show();
                $('#BtnBayarPotongancicil').show();
                this.Cekvalidasi();
                this.Cekvalidasicicillunas();
            },

            setdate(){
                $('#tgl_potonganx').attr('max',this.date_potongan_bayarx)
            },

            today(){
                var today = new Date();
                var dd = String(today.getDate()).padStart(2, '0');
                var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
                var yyyy = today.getFullYear();
                var HH = today.getHours();
                var minutes = today.getMinutes();
                today = yyyy + '-' + mm + '-' + dd + 'T' + HH +':'+ minutes + ":00";
                this.date_potongan_bayarx = today
            },


            Cekvalidasi(){
            	var tanggalValid = $("#tgl_potonganx")[0].checkValidity();
	            (tanggalValid) ? $("#cekTanggalValid").hide() : $("#cekTanggalValid").show();
                var nominalpotongan = this.nominal_pembayaranx;
                var datepotonganx = this.date_potongan_bayarx;
                var selectedakun = this.selectedx.value !== undefined ? this.selectedx.value : "";
                var tipepembayaraan = this.tipepembayaraan;
                // if (nominalpotongan>0 && datepotonganx !== '' && selectedakun && tipepembayaraan !=='0' && tanggalValid) {
                //     $('#BtnBayarPotongan').prop('disabled', false);
                //     $('#BtnBayarPotongancicil').prop('disabled', false);
                // } else {
                //     $('#BtnBayarPotongan').prop('disabled', true);
                //     $('#BtnBayarPotongancicil').prop('disabled', true);
                // }
	            $('#BtnBayarPotongan').prop('disabled', false);
	            $('#BtnBayarPotongancicil').prop('disabled', false);
            },

            Cekvalidasicicillunas(){
	            var tanggalValid = $("#tgl_potonganx")[0].checkValidity();
	            (tanggalValid) ? $("#cekTanggalValid").hide() : $("#cekTanggalValid").show();
                var nominalpotongan = this.saldo_potonganbayarx;
                var datepotonganx = this.date_potongan_bayarx;
                var selectedakun = this.selectedx.value !== undefined ? this.selectedx.value : "";
                var tipepembayaraan = this.tipepembayaraan;

                // if (nominalpotongan>0 && datepotonganx !== '' && selectedakun && tipepembayaraan !=='0' && tanggalValid) {
                //     $('#BtnBayarPotongancicil').prop('disabled', false);
                // } else {
                //     $('#BtnBayarPotongancicil').prop('disabled', true);
                // }
	            $('#BtnBayarPotongancicil').prop('disabled', false);
            },

            Cekvalidasicicil(){
	            var tanggalValid = $("#tgl_potonganx")[0].checkValidity();
	            (tanggalValid) ? $("#cekTanggalValid").hide() : $("#cekTanggalValid").show();
                var nominalpotongan = this.nominal_cicil_bayarx;
                var datepotonganx = this.date_potongan_bayarx;
                var selectedakun = this.selectedx.value !== undefined ? this.selectedx.value : "";
                var tipepembayaraan = this.tipepembayaraan;
                // if (nominalpotongan>0 && datepotonganx !== '' && selectedakun && tipepembayaraan !=='0' && tanggalValid) {
                //     $('#BtnBayarPotongans').prop('disabled', false);
                // } else {
                //     $('#BtnBayarPotongans').prop('disabled', true);
                // }
	            $('#BtnBayarPotongans').prop('disabled', false);
            },

            maxsaldo(){
              var maxcicil = this.nominal_cicil_bayarx;
              if(maxcicil>this.saldo_potonganbayarx){
                  $('#BtnBayarPotongans').prop('disabled', true);
              }else{

              }
            },

            inputnominalcicil(){
                var handlecicil = this.nominal_cicil_bayarx;
                var hasilcicil = handlecicil.replace(/[^0-9]+/g,'');
                this.nominal_cicil_bayarx=hasilcicil;
                // this.maxsaldo()
                this.formatrupiahnominalcicilx();
                this.Cekvalidasicicil();
            },

            formatrupiahnominalcicilx(){
                var rupiahcicil = this.nominal_cicil_bayarx;
                var formattedrupiahcicil = this.newrupiahnominalcicilx(rupiahcicil);
                this.nominal_cicil_bayarx=formattedrupiahcicil;
            },

            newrupiahnominalcicilx(angka, prefix){
                /* Fungsi formatRupiah */
                var number_string = angka.replace(/[^,\d]/g, "").toString(),
                    split = number_string.split(","),
                    sisa = parseInt(split[0]).toString().length % 3,
                    rupiah = parseInt(split[0]).toString().substr(0, sisa),
                    ribuan = parseInt(split[0]).toString().substr(sisa).match(/\d{3}/gi);
                // tambahkan titik jika yang di input sudah menjadi angka ribuan
	            if (ribuan) {
                    var separator = sisa ? "." : "";
                    rupiah += separator + ribuan.join(".");
                }

                rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
                return prefix == undefined ? rupiah : rupiah ? "Rp." + rupiah : "";
            },

            inputnominallunas(){
                var handlecicil = this.nominal_pembayaranx;
                var hasilcicil = handlecicil.replace(/[^0-9]+/g,'');
                this.nominal_pembayaranx=hasilcicil;
                this.formatrupiahnominallunasx();
                this.Cekvalidasi();
            },

            formatrupiahnominallunasx(){
                var rupiahcicil = this.nominal_pembayaranx;
                var formattedrupiahcicil = this.newrupiahnominallunasx(rupiahcicil);
                this.nominal_pembayaranx=formattedrupiahcicil;
            },

            newrupiahnominallunasx(angka, prefix){
                /* Fungsi formatRupiah */
                var number_string = angka.replace(/[^,\d]/g, "").toString(),
                    split = number_string.split(","),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);
                // tambahkan titik jika yang di input sudah menjadi angka ribuan
                if (ribuan) {
                    var separator = sisa ? "." : "";
                    rupiah += separator + ribuan.join(".");
                }

                rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
                return prefix == undefined ? rupiah : rupiah ? "Rp." + rupiah : "";
            },

            inputnominalcicillunas(){
                var handlecicillunas = this.saldo_potonganbayarx;
                var hasilcicillunas = handlecicillunas.replace(/[^0-9]+/g,'');
                this.saldo_potonganbayarx=hasilcicillunas;
                this.formatrupiahnominalcicillunasx();
                this.Cekvalidasi();
            },

            formatrupiahnominalcicillunasx(){
                var rupiahcicillunas = this.saldo_potonganbayarx;
                var formattedrupiahcicillunas = this.newrupiahnominalcicillunasx(rupiahcicillunas);
                this.saldo_potonganbayarx=formattedrupiahcicillunas;
            },

            newrupiahnominalcicillunasx(angka, prefix){
                /* Fungsi formatRupiah */
                var number_string = angka.replace(/[^,\d]/g, "").toString(),
                    split = number_string.split(","),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);
                // tambahkan titik jika yang di input sudah menjadi angka ribuan
                if (ribuan) {
                    var separator = sisa ? "." : "";
                    rupiah += separator + ribuan.join(".");
                }

                rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
                return prefix == undefined ? rupiah : rupiah ? "Rp." + rupiah : "";
            },

            inputnominalsisabayar(){
                var handlecicillunas = this.sisabayarx;
                var hasilcicillunas = handlecicillunas.replace(/[^0-9]+/,'');
                this.sisabayarx=hasilcicillunas;
                this.formatrupiahnominalsisabayar();
                this.Cekvalidasi();
            },

            formatrupiahnominalsisabayar(){
                var rupiahcicillunas = this.sisabayarx;
                var formattedrupiahcicillunas = this.newrupiahnominalcicillunasx(rupiahcicillunas);
                this.sisabayarx=formattedrupiahcicillunas;
            },

            newrupiahnominalsisabayar(angka, prefix){
                /* Fungsi formatRupiah */
                var number_string = angka.replace(/[^,\d]/g, "").toString(),
                    split = number_string.split(","),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);
                // tambahkan titik jika yang di input sudah menjadi angka ribuan
                if (ribuan) {
                    var separator = sisa ? "." : "";
                    rupiah += separator + ribuan.join(".");
                }

                rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
                return prefix == undefined ? rupiah : rupiah ? "Rp." + rupiah : "";
            },

            async getdatakaunx() {
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/penggajian/meta/list_akun_keuangan',this.requestHeaders);
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            $('#loadingPage').removeClass('overlayLoading');
                            $('#loadingPage').hide()
                            var dataakun = response.data.data;
                            this.selectedakun.push({id: "", text: "Pilih Akun Kas"});
                            for (var i = 0; i < dataakun.length; i++) {
                                this.selectedakun.push({id: dataakun[i].idakun, text: dataakun[i].nama_akun, idkategori: dataakun[i].idkategori})
                            }

                        }
                    }

                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#loadingPage').hide()
                }
            },

            async getDetailpotonganbayarsx() {
                this.namaworkshopbayarx = '';
                this.namaoutletbayarx='';
                this.statusoutletbayarx='false';
                this.statusworkshopbayarx='false';
                this.statuskurirbayarx='false';
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                $('#input-nominal-cicil').hide();
                $('#BtnBayarPotongans').hide();
                this.today();
                this.setdate();
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/penggajian/meta/detail_potongan?idpotongan=' + this.dataidpotonganx.idpotonganx,this.requestHeaders);
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            $('#loadingPage').removeClass('overlayLoading');
                            $('#loadingPage').hide()
                            var detailpotonganx = response.data.data.detail;
                            var data = response.data.data;
                            var lenght_potbay = detailpotonganx.potongan_bayar.length;
                            this.namakaryawan_potonganbayarx = detailpotonganx.karyawan.nama;
                            this.idkaryawan_potonganbayarx = detailpotonganx.karyawan.idkaryawan;
                            this.idpotongan_bayarx = detailpotonganx.id
                            this.keterangankaryawan_potonganbayarx = detailpotonganx.keterangan;
                            var nominal = detailpotonganx.nominal;
                            var saldo = detailpotonganx.saldo;
                            var sisax = nominal - saldo;
                            var toRp = this.newrupiahnominallunasx(nominal.toString());
                            var toRpsaldo = this.newrupiahnominalcicillunasx(saldo.toString());
                            var toRpsisa = this.newrupiahnominalsisabayar(sisax.toString());
                            this.sisabayarx=toRpsisa;
                            this.nominal_pembayaranx = toRp;
                            this.saldo_potonganbayarx = toRpsaldo;
                            this.date_lunas_potonganbayarx = data.waktu_potongan;
                            this.waktu_pembayaraan_bayar = data.waktu_pembayaran_terakhir;
                            this.statuspelunasanbayar = detailpotonganx.status_pelunasan;
                            var replaceutc = detailpotonganx.waktu.substring(0, 16) + ":00"
                            $('#tgl_potonganx').attr('min',replaceutc);
                            if(lenght_potbay>1){
                                this.statusriwayatbayar_bayar = 1;
                            }
                            if (detailpotonganx.karyawan.daftar_karyawan_outlet != null) {
                                this.namaoutletbayarx = detailpotonganx.karyawan.daftar_karyawan_outlet.outlet.nama;
                                this.statusoutletbayarx = "true";

                            }
                            if (detailpotonganx.karyawan.daftar_karyawan_workshop != null) {
                                this.namaworkshopbayarx = detailpotonganx.karyawan.daftar_karyawan_workshop.workshop.nama;
                                this.statusworkshopbayarx = "true";
                            }

                            if (detailpotonganx.karyawan.daftar_karyawan_kurir != null) {
                                this.statuskurirbayarx = "true";
                            }

                        }
                    }

                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#loadingPage').hide()
                }
            },

	        errorValidation() {
		        this.$v.selectedx.value.$touch()
		        return this.$v.selectedx.value.$invalid
	        },
            async createbayarpotongan(){
	            if (this.errorValidation()) {
		            this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
		            return
	            }
                this.isClicked = true;
                $('#BtnBayarPotongan').prop('disabled', true);
                $('#textBtnBayarPotongan').hide();
                var coba1 = this.date_potongan_bayarx;
                var dateparse = coba1.replace('T', ' ');
                var plussecond = dateparse;
                try {
                    const potonganx = new FormData;
                    potonganx.append('idkaryawan', this.idkaryawan_potonganbayarx)
                    potonganx.append('tipe_pembayaran', this.tipepembayaraan)
                    potonganx.append('nominal',  this.nominal_pembayaranx)
                    potonganx.append('idakun', this.selectedx.value !== undefined ? this.selectedx.value : "")
                    potonganx.append('idpotongan', this.idpotongan_bayarx)
                    potonganx.append('tanggal_pembayaran', plussecond)
                    const response = await this.$axios.post(this.$baseurl + '/masterData/penggajian/bayar_potongan_karyawan',potonganx, this.requestHeaders);
                    if (response.data.status === true) {
                        this.selectedkaryawan='';
                        this.nominal_potonganx='';
                        plussecond ='';
                        this.keterangan_potonganx='';
                        this.$toast.success(response.data.msg)
                        this.isClicked = false;
                        $('#BtnBayarPotongan').prop('disabled', false);
                        $('#textBtnBayarPotongan').show();
                        this.backtolistpotongansx()
                    }else{
                    	this.$toast.error(response.data.msg)
                        this.isClicked = false;
                        $('#BtnBayarPotongan').prop('disabled', false);
                        $('#textBtnBayarPotongan').show();
                    }
                }  catch (e) {
                	this.$catch_error_response(e)
	                this.isClicked = false;
	                $('#BtnBayarPotongan').prop('disabled', false);
	                $('#textBtnBayarPotongan').show();
                }
            },

            async createbayarpotongans(){
	            if (this.errorValidation()) {
		            this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
		            return
	            }
                this.isClicked = true;
                $('#BtnBayarPotongans').prop('disabled', true);
                $('#textBtnBayarPotongans').hide();
                var coba1 = this.date_potongan_bayarx;
                var dateparse = coba1.replace('T', ' ');
                var plussecond = dateparse;
                try {
                    const potonganx = new FormData;
                    potonganx.append('idkaryawan', this.idkaryawan_potonganbayarx)
                    potonganx.append('tipe_pembayaran', this.tipepembayaraan)
                    potonganx.append('nominal',  this.nominal_cicil_bayarx)
                    potonganx.append('idakun', this.selectedx.value !== undefined ? this.selectedx.value : "")
                    potonganx.append('idpotongan', this.idpotongan_bayarx)
                    potonganx.append('tanggal_pembayaran', plussecond)
                    const response = await this.$axios.post(this.$baseurl + '/masterData/penggajian/bayar_potongan_karyawan',potonganx, this.requestHeaders);
                    if (response.data.status === true) {
                        this.idkaryawan_potonganbayarx='';
                        this.tipepembayaraan='';
                        plussecond ='';
                        this.selectedx={
                        	text: "",
	                        value: "",
                        };
                        this.$toast.success(response.data.msg)
                        this.isClicked = false;
                        $('#BtnBayarPotongans').prop('disabled', false);
                        $('#textBtnBayarPotongans').show();
                        this.backtolistpotongansx()
                    }else{
                    	this.$toast.error(response.data.msg)
                        this.isClicked = false;
                        $('#BtnBayarPotongans').prop('disabled', false);
                        $('#textBtnBayarPotongans').show();
                    }
                }  catch (e) {
                	this.$catch_error_response(e)
	                this.isClicked = false;
	                $('#BtnBayarPotongans').prop('disabled', false);
	                $('#textBtnBayarPotongans').show();
                }
            },

            async createbayarpotongancicil(){
	            if (this.errorValidation()) {
		            this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
		            return
	            }
                this.isClicked = true;
                $('#BtnBayarPotongancicil').prop('disabled', true);
                $('#textBtnBayarPotongancicil').hide();
                var coba1 = this.date_potongan_bayarx;
                var dateparse = coba1.replace('T', ' ');
                var plussecond = dateparse;
                try {
                    const potonganx = new FormData;
                    potonganx.append('idkaryawan', this.idkaryawan_potonganbayarx)
                    potonganx.append('tipe_pembayaran', this.tipepembayaraan)
                    potonganx.append('nominal',  this.saldo_potonganbayarx)
                    potonganx.append('idakun', this.selectedx.value !== undefined ? this.selectedx.value : "")
                    potonganx.append('idpotongan', this.idpotongan_bayarx)
                    potonganx.append('tanggal_pembayaran', plussecond)
                    const response = await this.$axios.post(this.$baseurl + '/masterData/penggajian/bayar_potongan_karyawan',potonganx, this.requestHeaders);
                    if (response.data.status === true) {
                        this.idkaryawan_potonganbayarx='';
                        this.tipepembayaraan='';
                        plussecond ='';
                        this.selectedx={
                        	text: "",
	                        value: ""
                        };
                        this.$toast.success(response.data.msg)
                        this.isClicked = false;
                        $('#BtnBayarPotongancicil').prop('disabled', false);
                        $('#textBtnBayarPotongancicil').show();
                        this.backtolistpotongansx()
                    }else{
                    	this.$toast.error(response.data.msg)
                        this.isClicked = false;
                        $('#BtnBayarPotongancicil').prop('disabled', false);
                        $('#textBtnBayarPotongancicil').show();
                    }
                }  catch (e) {
                	this.$catch_error_response(e)
	                this.isClicked = false;
	                $('#BtnBayarPotongancicil').prop('disabled', false);
	                $('#textBtnBayarPotongancicil').show();
                }
            },

        }
    }
</script>

<style>

</style>